// TODO! REVISIT THIS FILE
import { parseCludoEngineID } from '../../utils/parse-cludo-engine';
import { LanguageService } from '../language';
import { Alternate } from '../language/types';
import { StoryblokService } from '../storyblok';
import { AlternateLanguageLink } from './types';

const additionalWhiteListedDomains: string[] = ['assets.roche.com', 'assets.cwp.roche.com'];

export const getTagPageUrl = (): string => 'topic';

export function getWebsiteName(): string {
  return process.env.GATSBY_WEBSITE_NAME === 'debug-roche-ch-staging'
    ? 'roche-ch'
    : (process.env.GATSBY_WEBSITE_NAME ?? '');
}

export function getWhiteListedDomains(): string[] {
  const domains: string[] = [...additionalWhiteListedDomains];
  try {
    const parsedDomains = JSON.parse(process.env.GATSBY_WHITE_LISTED_DOMAINS ?? '[]');
    domains.push(...parsedDomains);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Parsing GATSBY_WHITE_LISTED_DOMAINS failed: ', error);
  }
  return domains;
}

export function getAlternates(alternates: Alternate[] | undefined) {
  if (!alternates) {
    return [];
  }

  return alternates
    .map((alternate) => {
      const { full_slug: storySlug, published } = alternate;

      // get alternates for topic pages
      if (storySlug?.includes('/topic/')) {
        return {
          locale: LanguageService.getLocaleFromSlug(storySlug),
          url: storySlug,
        };
      }

      // for the default homepage in the default language (e.g. DE in Switzerland, but not for FR in Switzerland) the
      // url needs to be '/' instead of 'home' (which is the official slug)
      const defaultHomepageSlug = process.env.GATSBY_HOME_STORY_SLUG;
      if (storySlug === defaultHomepageSlug) {
        return {
          locale: LanguageService.getLocaleFromSlug(storySlug),
          url: '/',
        };
      }

      if (published || StoryblokService.isInEditor()) {
        return {
          locale: LanguageService.getLocaleFromSlug(storySlug),
          url: storySlug,
        };
      }

      return undefined;
    })
    .filter((alternate): alternate is AlternateLanguageLink => alternate !== undefined);
}

export function getCludoEngineId(locale: string): string {
  return process.env.GATSBY_CLUDO_ENGINE_ID ?? parseCludoEngineID(process.env.GATSBY_CLUDO_ENGINE_ID_LIST, locale);
}
